import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "feature-toggle",
    { attrs: { toggle: "enableCompetitorSimulation" } },
    [
      _c(
        VRow,
        { staticClass: "title-row" },
        [
          _c(VCol, { attrs: { cols: "12" } }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("workPackages.costChangeThresholds.label")) +
                "\n    "
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        VRow,
        { staticClass: "input-row" },
        [
          _c(
            VCol,
            { staticClass: "pt-0 pb-0 pr-2", attrs: { cols: "6" } },
            [
              _c(VTextField, {
                attrs: {
                  label: _vm.$t("workPackages.costChangeThresholds.min"),
                  disabled: _vm.disabled,
                  type: "text",
                },
                on: {
                  blur: _vm.formatInputOnBlur,
                  keypress: function ($event) {
                    return _vm.ensureDecimal($event, true)
                  },
                  paste: function ($event) {
                    return _vm.ensurePastedDecimal($event, true)
                  },
                },
                model: {
                  value: _vm.costChangeThresholdMinDisplay,
                  callback: function ($$v) {
                    _vm.costChangeThresholdMinDisplay = $$v
                  },
                  expression: "costChangeThresholdMinDisplay",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            VCol,
            { staticClass: "pt-0 pb-0 pl-2", attrs: { cols: "6" } },
            [
              _c(VTextField, {
                attrs: {
                  label: _vm.$t("workPackages.costChangeThresholds.max"),
                  disabled: _vm.disabled,
                  type: "text",
                },
                on: {
                  blur: _vm.formatInputOnBlur,
                  keypress: function ($event) {
                    return _vm.ensureDecimal($event, true)
                  },
                  paste: function ($event) {
                    return _vm.ensurePastedDecimal($event, true)
                  },
                },
                model: {
                  value: _vm.costChangeThresholdMaxDisplay,
                  callback: function ($$v) {
                    _vm.costChangeThresholdMaxDisplay = $$v
                  },
                  expression: "costChangeThresholdMaxDisplay",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.validationError
        ? _c(
            VRow,
            { attrs: { "no-gutters": "" } },
            [
              _c(VCol, { staticClass: "pa-2", attrs: { cols: "12" } }, [
                _c("div", { staticClass: "error--text text-body2" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t(
                          "workPackages.costChangeThresholds.errors.minGreaterThanMax"
                        )
                      ) +
                      "\n      "
                  ),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }